import React, { useContext, useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import { IoMdArrowDropdown } from 'react-icons/io'
import { IoChevronBackOutline, IoClose } from 'react-icons/io5'
import { BiCheck, BiEdit } from 'react-icons/bi'

import Renderif from '../../components/renderif'
import DropDown, { DropDownOption } from '../../components/dropdown'
import BVCalendar from '../../components/calendar'
import { Service } from '../../services/api'
import { AuthContext } from '../../context/auth_context'

import ApiCalendar from "react-google-calendar-api";
import { AlertContext } from '../../context/alert_context'
import Loader from '../../components/loader'
import { primary } from '../../utils/colors'
import { GoStarFill } from 'react-icons/go'
import { useNavigate } from 'react-router-dom'
import CheckBoxAddSpecialist from '../../components/checkbox-agregar-especialista'


export default function AgregarEspecialista({ onClose = () => { } }) {

    const navigate = useNavigate();

    let date = new Date();
    date.setDate(date.getDate() + 1)

    const { user } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    const [state, setState] = useState({

        loading: false,
        rol_active: null,
        specialist: {
            firstName: '',
            lastName: '',
            email: '',
            birthDate: '2024-03-06',
            cellPhone: '',
            speciality: 'General',
            rol: 1,
            startDate: '9:00',
            endDate: '18:00'
        }

    })
    const [DaySchedules, setDaySchedules] = useState([])

    function assignDay(day) {
        // console.log(state);
        var index = -1;

        if (DaySchedules.find(x => x.DayOfWeek == day)) {
            DaySchedules.find(function(item, i){
                if(item.DayOfWeek == day){
                  index = i;
                  return i;
                }
              });
            //   console.log(DaySchedules[index]);
                DaySchedules.splice(index,1);
        }
        else {
            let dayObj = [...DaySchedules, {
                "DayOfWeek": day,
                "TimeRanges": [
                    {
                        "StartTime": "09:00:00",
                        "EndTime": "12:00:00"
                    },
                    {
                        "StartTime": "14:00:00",
                        "EndTime": "18:00:00"
                    }
                ]
            }]
            setDaySchedules(dayObj)
        }
        // console.log(DaySchedules);
    }

    useEffect(() => {


        const init = async () => {

        }
        init()

        return () => { }

    }, [])

    const onCreateSpecialist = async () => {
        setState({ ...state, loading: true })

        let body = {
            ...state.specialist,
            DaySchedules
        }

        console.log(body)
        switch (state.specialist.rol) {
            case 'Admin':
                body.rol = 0
                break;
            case 'Coach':
                body.rol = 1
                break;
            // case 'Coach':
            //     body.rol = 1
            // break;

            default:
                break;
        }

        let add_specialist = await Service('POST', 'Admin/register-specialist', body)
        console.log(add_specialist);
        if (add_specialist.status === 200) {
            notify({ title: 'Listo!', message: 'Se ha añadido un nuevo especialista.', type: 'success' })
            onClose(body)
        } else {
            notify({ title: 'Error!', message: 'No ha sido posible añadir un nuevo especialista.', type: 'error' })
        }
        setState({ ...state, loading: false })

    }



    var arr = [
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
    ]

    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var months = new Array(7);
    months[0] = "January";
    months[1] = "Febrary";
    months[2] = "March";
    months[3] = "April";
    months[4] = "May";
    months[5] = "June";
    months[6] = "July";
    months[7] = "August";
    months[8] = "September";
    months[9] = "Octuber";
    months[10] = "November";
    months[11] = "December";


    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <div className='overlay d-flex justify-content-center align-items-center'>


                <div className='bv-modal overflow-auto hide-scroll shadow'>

                    <div className='d-flex  p-3'>

                        <div className='d-flex align-items-center'>
                            <div className='avatar avatar--big me-2'></div>

                        </div>
                        <div className='col'></div>
                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                            onClose()
                        }}>
                            <IoClose size={30} color={primary}></IoClose>
                        </div>


                    </div>

                    <div className='d-flex px-3'>

                        <div className='col px-3'>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Nombre</div>
                                <div className='input--light'>
                                    <input value={state.specialist.firstName} onChange={(evt) => {
                                        state.specialist.firstName = evt.currentTarget.value
                                        setState({ ...state })
                                    }} placeholder='Nombre Apellido'></input>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Apelidos</div>
                                <div className='input--light'>
                                    <input value={state.specialist.lastName} onChange={(evt) => {
                                        state.specialist.lastName = evt.currentTarget.value
                                        setState({ ...state })
                                    }} placeholder='Nombre Apellido'></input>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Correo electrónico</div>
                                <div className='input--light'>
                                    <input value={state.specialist.email} onChange={(evt) => {
                                        state.specialist.email = evt.currentTarget.value
                                        setState({ ...state })
                                    }} placeholder='correo@dominio.com'></input>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Teléfono</div>
                                <div className='input--light'>
                                    <input type='number' value={state.specialist.cellPhone} onChange={(evt) => {
                                        state.specialist.cellPhone = evt.currentTarget.value
                                        setState({ ...state })
                                    }} placeholder='11 22 33 44 55'></input>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Especialidad</div>
                                <DropDown
                                    title='Seleccione la Especialidad deseada'
                                    open={false}
                                    // defaultValue={0} 
                                    // value={'Autoestima'}
                                    _onChange={(evt) => {
                                        console.log(evt)
                                        state.specialist.speciality = evt.value
                                        setState({ ...state })
                                    }}>
                                    <DropDownOption value={'General'} label="Default - General">
                                        <div className='f-14 text-gray'>Default - General</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Autoestima'} label="Autoestima">
                                        <div className='f-14 text-gray'>Autoestima</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Adolescencia'} label="Adolescencia">
                                        <div className='f-14 text-gray'>Adolescencia</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Balance Trabajo-Familia'} label="Balance Trabajo-Familia">
                                        <div className='f-14 text-gray'>Balance Trabajo-Familia</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Duelos y Pérdidas'} label="Duelos y Pérdidas">
                                        <div className='f-14 text-gray'>Duelos y Pérdidas</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Desarrollo de la mujer'} label="Desarrollo de la mujer">
                                        <div className='f-14 text-gray'>Desarrollo de la mujer</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Gestión de tiempo'} label="Gestión de tiempo">
                                        <div className='f-14 text-gray'>Gestión de tiempo</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Problemas laborales'} label="Problemas laborales">
                                        <div className='f-14 text-gray'>Problemas laborales</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Problemas de Pareja'} label="Problemas de Pareja">
                                        <div className='f-14 text-gray'>Problemas de Pareja</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Problemas de Crianza'} label="Problemas de Crianza">
                                        <div className='f-14 text-gray'>Problemas de Crianza</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Problemas Emocionales'} label="Problemas Emocionales">
                                        <div className='f-14 text-gray'>Problemas Emocionales</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Paternidad'} label="Paternidad">
                                        <div className='f-14 text-gray'>Paternidad</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Salud'} label="Salud">
                                        <div className='f-14 text-gray'>Salud</div>
                                    </DropDownOption>
                                    <DropDownOption value={'Superacion Personal'} label="Superacion Personal">
                                        <div className='f-14 text-gray'>Superacion Personal</div>
                                    </DropDownOption>

                                </DropDown>
                            </div>

                            {/* <div className='mt-3'>
                            <div className='f-14 bold text-gray'>Asignar a equipo</div>
                            <DropDown 
                                title='Seleccione la Especialidad deseada'
                                open={false}
                                defaultValue={0} 
                                _onChange={(evt)=>{ }}>
                                <DropDownOption value={0} label="Default - General">
                                    <div className='f-14 text-gray'>Default - General</div>
                                </DropDownOption>
                            </DropDown>
                        </div> */}
                        </div>


                        <div className='col px-3'>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Fecha de Nacimiento</div>
                                <div className='input--light'>
                                    <input onChange={(evt) => {

                                        // state.specialist.birthDate = new Date(Date.parse(evt.currentTarget.value))
                                        // setState({...state})
                                    }} type="date" placeholder='Nombre Apellido'></input>
                                </div>
                            </div>

                            <div className='mt-3'>
                                <div className='f-14 bold text-primary'>Horario Laboral</div>
                                <div className='mt-3'>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(1)} label="Lunes"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(2)} label="Martes"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(3)} label="Miércoles"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(4)} label="Jueves"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(5)} label="Viernes"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(6)} label="Sábado"></CheckBoxAddSpecialist>
                                    <CheckBoxAddSpecialist assignDay={() => assignDay(7)} label="Domingo"></CheckBoxAddSpecialist>
                                </div>
                            </div>

                            <div className='d-flex mt-3'>
                                <div className='col'>
                                    <div className=''>
                                        <div className='f-14 text-gray bold'>Horario Entrada</div>
                                        <div className='f-14 text-gray '>09:00</div>
                                    </div>
                                </div>

                                <div className='col'>
                                    <div className=''>
                                        <div className='f-14 text-gray bold'>Horario Entrada</div>
                                        <div className='f-14 text-gray '>18:00</div>
                                    </div>
                                </div>
                            </div>



                        </div>



                    </div>
                    <div className='mt-3 px-4 pb-4'>
                        <div className='f-16 bold text-primary'>Permisos</div>

                        <div className='d-flex mt-3'>
                            <div className='col'>
                                <CheckBoxAddSpecialist onChange={(value) => {
                                    if (value) {

                                        state.specialist.rol = 0
                                        setState({ ...state })
                                    }
                                }} checked={state.specialist.rol === 0 ? true : false} label="Admin"></CheckBoxAddSpecialist>
                            </div>

                            <div className='col'>
                                <CheckBoxAddSpecialist onChange={(value) => {
                                    if (value) {
                                        state.specialist.rol = 1
                                        setState({ ...state })
                                    }
                                }} checked={state.specialist.rol === 1 ? true : false} label="Coach"></CheckBoxAddSpecialist>
                            </div>

                            {/* <div className='col'>
                            <CheckBox onChange={(value)=>{
                                if(value){
                                    state.specialist.rol = 'Coach'
                                    setState({...state})
                                }
                            }} checked={state.specialist.rol === 'Coach' ? true : false} text="Coach"></CheckBox>
                        </div> */}
                        </div>
                    </div>

                    <div className='d-flex b-top p-4'>

                        <div className='col'></div>

                        <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                            onClose()
                        }}>Cancelar</div>

                        <div className='bv-pill bv-pill--green cursor-pointer px-4' onClick={() => {
                            onCreateSpecialist()
                        }}>Guardar</div>
                    </div>

                    <div className=''></div>







                </div>


            </div>
        </>
    )
}
